export default __webpack_public_path__ + "static/media/nft-logo-banner.db1916ee.png";